const siteUrl = (process.env.VUE_APP_SITE_URL || 'https://www.vanovy.com').replace(/\/$/, '');

export const BRAND_NAME = 'Vanovy';
export const BRAND_DOMAIN = 'vanovy.com';
export const BRAND_URL = siteUrl;
export const BRAND_SUPPORT_EMAIL = 'support@vanovy.com';

export function brandAsset(path) {
  const normalized = String(path || '').replace(/^\//, '');
  return `${BRAND_URL}/${normalized}`;
}

export default {
  BRAND_NAME,
  BRAND_DOMAIN,
  BRAND_URL,
  BRAND_SUPPORT_EMAIL,
  brandAsset,
};
